import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";


declare var ko: any;

export class configTagsList_template extends vnTemplate{

    public simpleFilter: filterSimple_template;
    public resultsInfo: resultsInfo_template;
    public pagination: pagination_template;

    protected getTemplateHtml(): string{

        return  `  
                <div class="list-header w-justify">
                    <div class="w-left">
                        <div class="form-check-inline">                  
                            <input type="checkbox" data-bind="checked: isShowSelectableTags, click: showSelectableTags" id="showSelectableTag">
                            <label for="showSelectableTag" class="form-label icon i-check">Show Selectable Tags</label>   
                        </div>
                    </div>
                    
                    <div class="w-center"> 
                        ` + this.simpleFilter.getHtmlBuild() + `
                    </div>
                    
                    <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
                </div>
                
                 <div class="w-list-results" id="list-results">
                   <table class="list-results">
                    ` + this.resultsInfo.getHtmlBuild() + `
                        <thead>
                            <input data-bind="value: orderBy" type="hidden">
                            <input data-bind="value: orderByDirection" type="hidden">
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 't.id') }, css: { 'list-sort-desc': orderByAndDirection()=='t.id_DESC', 'list-sort-asc': orderByAndDirection()=='t.id_ASC' }" class="icon i-dropdown-simple">id</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 't.name') }, css: { 'list-sort-desc': orderByAndDirection()=='t.name_DESC', 'list-sort-asc': orderByAndDirection()=='t.name_ASC' }" class="icon i-dropdown-simple">name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'd.slug') }, css: { 'list-sort-desc': orderByAndDirection()=='d.slug_DESC', 'list-sort-asc': orderByAndDirection()=='d.slug_ASC' }" class="icon i-dropdown-simple">slug</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'd.description') }, css: { 'list-sort-desc': orderByAndDirection()=='d.description_DESC', 'list-sort-asc': orderByAndDirection()=='d.description_ASC' }" class="icon i-dropdown-simple">Description</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'd.isSelectable') }, css: { 'list-sort-desc': orderByAndDirection()=='d.isSelectable_DESC', 'list-sort-asc': orderByAndDirection()=='d.isSelectable_ASC' }" class="icon i-dropdown-simple">Selectable</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: tags">
                            <tr class="cursor" >
                                <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: id"></span></td>
                                <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: name"></span></td>
                                <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: slug"></span></td>
                                <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: description"></span></td>
                                <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: isSelectable"></span></td>
                            </tr>
                        <tbody>
                    </table>
                </div>
            `;

    }

    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);
        this.resultsInfo = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
    }


    protected getTemplateName(): string{
        return "configTags-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            orderBy: ko.observable("t.name")
            , orderByAndDirection: ko.observable("name_ASC")
            , orderByDirection: ko.observable("ASC")
            , tags: ko.observableArray([])
            , isShowSelectableTags: ko.observable(false)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickView: function (value) {
                huit_neuf_this.onClickView(value);
            },
            showSelectableTags: function (data) {
                huit_neuf_this.showSelectableTags();
                return true;
            }
        };
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy
            ,orderByDirection: this.getTemplateViewModel().orderByDirection
            ,orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            ,filter : {
                keyword: this.getTemplateViewModel().simpleFilter.filterKeyword,
                isShowSelectableTags : this.getTemplateViewModel().isShowSelectableTags
            }
            ,pagination: this.getTemplateViewModel().pagination
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.tagListReorder();
    }

    public setTags(tags) {

        this.getTemplateViewModel().tags(tags);
    }

    public onClickView(value) {

        this.caller.viewTag(value.id);
    }

    public showSelectableTags(){

        this.caller.showTags();
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/configTagsList_template.ts